import { AddressModel } from './address-model';
import { GeoPositionModel } from './geo-position-model';
import { IPAddressRangeModel } from './ipaddress-range-model';

export class IPRangeModel {
  id: string;
  userId: string|null;
  orgUnitId: string|null;
  isSystem: boolean;
  name: string;
  ranges: IPAddressRangeModel[];
  position: GeoPositionModel;
  address: AddressModel;
  ignoreIP: boolean;
  ignoreGeocoding: boolean;
  locationLabel: string;
}
